import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@mui/material'
import clsx from 'clsx'

import EditableHTML from '@v4/components/common/EditableHTML'
import SortHandler from '@v4/components/common/SortHandler'
import Image from '@v4/components/common/Image'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useFooter1 } from './Footer1.hooks'

const Footer1 = props => {
	const [
		{
			classes,
			alignment,
			defaultOrder,
			direction,
			image,
			text,
			textConfig,
			textEditable,
			isCentered,
			textAlignment,
			withImage,
			textKey,
			sortHandlerParentRef,
		},
		{ handleImageClick, handleTextClick, handleTextChange },
	] = useFooter1(props)

	return (
		<Grid
			container
			alignItems="center"
			wrap="nowrap"
			className={clsx(classes.container, classes[alignment], 'footer1')}
			spacing={2}
			ref={sortHandlerParentRef}
		>
			<SortHandler parentRef={sortHandlerParentRef} defaultOrder={defaultOrder} direction={direction}>
				<Grid
					className={clsx(classes.logoWrap, 'footer1-logo-container')}
					size={{
						sm: !isCentered ? 6 : 'auto',
					}}
				>
					<Box className={clsx(classes.image, 'footer1-image')}>
						{withImage && <Image metaData={image} onClick={handleImageClick} />}
					</Box>
				</Grid>
				<Grid
					className={classes.empty}
					size={{
						sm: isCentered ? 6 : false,
					}}
				/>
				<Grid
					className={clsx(classes.textWrap, !text && isCentered && classes.empty, 'footer1-text-container')}
					size={{
						xs: 12,
						sm: 6,
					}}
				>
					<EditableContainer
						visible={!!text}
						fieldConfig={textConfig}
						onAdd={handleTextChange}
						editable={textEditable}
					>
						<EditableHTML
							key={textKey}
							align={textAlignment}
							displayEmpty
							className={clsx(classes.text, 'footer1-text-block')}
							html={text}
							onClick={handleTextClick}
							editable={textEditable}
							onChange={handleTextChange}
						/>
					</EditableContainer>
				</Grid>
			</SortHandler>
		</Grid>
	)
}

Footer1.propTypes = {
	meta: PropTypes.shape({
		alignment: PropTypes.instanceOf(PageMetaData),
		path: PropTypes.instanceOf(PageMetaData),
		copyRights: PropTypes.instanceOf(PageMetaData),
	}),
}

export default memo(Footer1)
